<template>
    <!-- 契約終了時に表示する既定メッセージ領域。契約終了ならこちらの div が表示される -->
    <div v-if="appData.terminatedContract" class="default-message" v-t="'message.error_contract_termination'">
    </div>

    <!-- 上記でない場合に表示されるメインのトーク画面パネル全体のラッパー -->
    <div v-else class="talk-panel">
        <table height="100%" width="100%" cellpadding=0 cellspacing=0>
            <tr height="55px">
                <td colspan=2>
                    <!-- 検索条件（日時・対象ユーザー/グループ）の入力エリア全体 -->
                    <div class="search">
                        <!-- 検索エリア内部の配置用コンテナ（レイアウト用） -->
                        <div class="serarch-contents">
                            <!-- 日付選択 UI のコンテナ。見出しと el-date-picker を内包 -->
                            <div class="date-picker">
                                <span v-t="'message.item_date'"></span>
                                <el-date-picker
                                    v-model="date"
                                    type="date"
                                    prefix-icon="noicon"
                                    clear-icon="noicon"
                                    placeholder="">
                                </el-date-picker>
                            </div>

                            <!-- 時刻範囲選択 UI のコンテナ。開始/終了の el-time-select を内包 -->
                            <div class="time-picker">
                                <span v-t="'message.item_time'"></span>
                                <el-time-select
                                    v-model="startTime"
                                    prefix-icon="noicon"
                                    clear-icon="noicon"
                                    :picker-options="{start: '00:00', step: '00:30', end: '24:00', maxTime: endTime}"
                                    placeholder="">
                                </el-time-select>
                                <span>-</span>
                                <el-time-select
                                    v-model="endTime"
                                    prefix-icon="noicon"
                                    clear-icon="noicon"
                                    :picker-options="{start: '00:00', step: '00:30', end: '24:00', minTime: startTime}"
                                    placeholder="">
                                </el-time-select>
                            </div>

                            <!-- 選択対象（トークグループ or P2P ユーザー）表示エリア全体 -->
                            <div class="display-target">
                                <!-- 選択中の対象タイプ（例: Group / User）をテキスト表示 -->
                                <span>{{ selectedItemType }}</span>

                                <!-- 選択済みタグ群の表示コンテナ。何か選択がある時のみ表示 -->
                                <div class="display-tags" v-if="selected.length > 0">

                                    <!-- トークグループ選択時の単一タグ表示（削除ボタン付き） -->
                                    <div class="selected-tag" v-if="isTalkgroup">
                                        <span>{{ selected[0].data.label }}</span>
                                        <span class="closeTag" @click="deleteUserTag(selected[0])">×</span>
                                    </div>

                                    <!-- P2P（ユーザー間）選択時のタグ表示エリア -->
                                    <div class="p2p-tags" v-else>
                                        <!-- 送信側（または一人目）のユーザータグ -->
                                        <div class="selected-tag">
                                            <span>{{ selected[0].data.label }}</span>
                                            <span class="closeTag" @click="deleteUserTag(selected[0])">×</span>
                                        </div>

                                        <!-- 相手ユーザー（2人目）が選択されている場合の表示。入れ替えボタンあり -->
                                        <div class="peer-user" v-if="selected.length == 2">
                                            <!-- 2ユーザーの入れ替えを行うボタン（双方向アイコン） -->
                                            <button class="transparent-button" @click="swapUserTag()"><img class="bidirectional" src="../../assets/icon_mutual.svg" alt=""></button>
                                            <!-- 受信側（または二人目）のユーザータグ -->
                                            <div class="selected-tag">
                                                <span>{{ selected[1].data.label }}</span>
                                                <span class="closeTag" @click="deleteUserTag(selected[1])">×</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>

            <tr class="itemheader">
                <!-- 左ペイン（オブジェクトツリー）領域。高さは行に依存、幅 50% -->
                <td width="50%" height="100%">
                    <div class="inner-panel">
                        <div class="objectTree" v-if="showTree">
                            <talk-object-tree
                                :initialData="initialDataForTree"
                                :showAdminUser="false"
                                @on-selectnode="handleOnSelectNode"
                                ref="talkObjectTree">
                            </talk-object-tree>
                        </div>
                    </div>
                </td>

                <!-- 右ペイン（トークリスト）領域。幅 50% -->
                <td width="50%">
                    <!-- 内側パネル。ID はスクロール領域の高さ計測等に利用される想定 -->
                    <div id="record-list-panel" class="inner-panel">
                        <!-- 縦方向スクロールを許可する領域。リストをスクロール表示 -->
                        <div class="scrollable">
                            <!-- トーク履歴一覧コンポーネント。検索条件や選択状態を受け取って一覧を表示 -->
                            <talk-right-pane
                                v-bind:selectedNode="selectedNode"
                                v-bind:appData="appData"
                                v-bind:isTalkgroup="isTalkgroup"
                                v-bind:date="date"
                                v-bind:startTime="startTime"
                                v-bind:endTime="endTime"
                                v-bind:languageIndex="languageIndex"
                                v-bind:selected="selected"
                                v-bind:selectedItemType="selectedItemType">
                            </talk-right-pane>
                        </div>
                    </div>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import constants from "@/components/constants.js";
import commonUtil from "@/components/commonutil.js";
import server from "@/components/ServerApi.js";
import TalkObjectTree from "./TalkObjectTree.vue";
import TalkRightPane from "./TalkRightPane.vue";

export default {
    data () {
        return {
          date: new Date(),
          startTime: '00:00',
          endTime: '24:00',
          selected: [],
          isTalkgroup: false,
          showTree: true,
          selectedItemType: null,
          languageIndex: 0,
          selectedNode: null, // ← 追加
          // Local mirrors of BuddyComCall flags to react to App.vue updates
          enableBuddyComCall: false,
          enableBuddyComCallTrial: false,
          exportTenants: [],
        }
    },
    computed: {
        tenantList() {
            return [
                ...(this.appData.tenantList[0] ? [this.appData.tenantList[0]] : []),
                ...this.exportTenants
                    .filter(t => (t.c2cOption & constants.C2C_OPTION.VIEW_GROUP_TALK_RECORD) !== 0)
                    .map(t => ({
                        tenantId: t.tenantId,
                        id: 1,
                        label: t.tenantName,
                        name: t.tenantName,
                        type: 0,
                        isLeaf: false,
                        connectUserId: t.wantUserId,
                    })),
            ];
        },
        initialDataForTree() {
            return this.tenantList;
        },
    },
    methods: {
        handleOnSelectNode(elnode) {
            switch (elnode.node.data.type) {
                case constants.OBJECT_NODE:
                    return;
                case constants.OBJECT_USER:
                case constants.OBJECT_ASSISTANT:
                case constants.OBJECT_CUSTOM_ASSISTANT:
                case constants.OBJECT_IP_RADIO:
                    if (this.isTalkgroup) {
                        this.selected = [];
                        this.isTalkgroup = false;
                        this.selectedItemType = "";
                    }

                    if (this.selected.length == 0) {
                        this.selectedItemType = commonUtil.getMessageText(this.$i18n,"item_user");
                        this.selected.push(elnode.node);
                    } else if (this.selected.length == 1) {
                        if (this.selected[0] !== elnode.node) {
                            this.selected.push(elnode.node);
                        }
                    } else if (this.selected.length == 2) {
                        if (this.selected[0] == elnode.node) {
                            commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_select_same_user"));
                            return;
                        }
                        this.selected.splice(1,1);
                        this.selected.push(elnode.node);
                    }
                    return;
                case constants.OBJECT_TALKGROUP:
                    this.selected = [];
                    this.selectedItemType = commonUtil.getMessageText(this.$i18n, "item_group");
                    this.selected.push(elnode.node);
                    this.isTalkgroup = true;
                    this.selectedNode = elnode; // ← 追加: これがないと getInfo() が動かない
                    return;
            }
        },
        swapUserTag() {
            this.selected.splice(0, 2, this.selected[1], this.selected[0]);
        },
        deleteUserTag(node) {
            var self = this;
            this.selected.some(function(value, i){
                if (value == node) {
                    self.selected.splice(i, 1);
                }
                if (self.selected.length == 0) {
                    self.selectedItemType = "";
                }
            });
        },
        setLanguageIndex() {
            let countryCode = this.appData.countryCodeAlpha3;
            let language = commonUtil.getLanguageIndexList(this.$i18n.locale).filter(function (item) {
                if (item.countryCode.indexOf(countryCode) >= 0) return true;
            });
            if (language.length == 0) {
                this.languageIndex = 2;
            } else {
                this.languageIndex = language[0].value;
            }
        },
        async getTenantConnectInfo() {
            const REQUEST_TENANT_INFO = 0;
            try {
                const res = await server.post('/gettenantconnectinfo', {type: REQUEST_TENANT_INFO});
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        this.exportTenants.push(...res.data.exportTenantList);
                        break;
                    default:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "getTenantConnectInfo").replace("{code}", res.data.status));
                        break;
                }
            } catch (e) {
                commonUtil.putExceptionErrorMessage(this, "getTenantConnectInfo", e);
            }
        },
        resetSelectedNode() {
          this.selectedNode = null;
        },
    },
    created () {
        this.setLanguageIndex();
        // Initialize local mirrors for BuddyComCall flags
        if (this.appData) {
            this.enableBuddyComCall = !!this.appData.enableBuddyComCall;
            this.enableBuddyComCallTrial = !!this.appData.enableBuddyComCallTrial;
        }
    },
    async mounted() {
        await this.getTenantConnectInfo();
    },
    components: {
        TalkObjectTree,
        TalkRightPane,
    },
    watch: {
        'appData.tenantList'() {
            this.showTree = false;
            this.$nextTick(() => {
                this.showTree = true;
                this.setLanguageIndex();
            });
        },
        tenantList() {
            this.showTree = false;
            this.$nextTick(() => {
                this.showTree = true;
                this.setLanguageIndex();
            });
        },
        // React to App.vue toggling BuddyComCall feature flags
        'appData.enableBuddyComCall'(val) { this.enableBuddyComCall = !!val; },
        'appData.enableBuddyComCallTrial'(val) { this.enableBuddyComCallTrial = !!val; },
        '$route' (to) {
            if (to.name == "Talk") {
                this.$refs.talkObjectTree.resetCurrentNode(true);
                this.selected = [];
                this.data = new Date();
                this.startTime = '00:00';
                this.endTime = '24:00';
                this.selectedItemType = null;
            }
        }
    },
    props: ['appData']
}
</script>

<style scoped>

table {
    border-collapse: collapse;
}

tr.itemheader {
    border-top: 1px solid #eeeeee;
}

.talk-panel {
    height: 100%;
    background-color: #ffffff;
}

.inner-panel {
    position:relative;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
    background-color: #ffffff;
}

.scrollable {
    width: 100%;
    height: 100%;
    min-width: 0;
}

select {
    height: 40px;
}

.search {
    width: 100%;
    background-color: #ecf1fa;
    display: table;
}

.serarch-contents {
    display: table-cell;
    vertical-align:middle;
}

.date-picker {
    display: inline-block;
    padding-left: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
}

.time-picker {
    display: inline-block;
    padding-left: 20px;
}

.display-target {
    display: inline-block;
    padding-left: 20px;
}

.display-tags {
    display: inline-block;
}

.p2p-tags {
    display: inline-block;
}

.peer-user {
    display: inline-block;
}

.selected-tag {
    display: inline-block;
    border: 1px solid;
    border-radius: 30px;
    border-color: #5171cb;
    background-color: #ffffff;
    color: #5171cb;
    margin: 5px;
    padding: 6px;
    padding-left: 10px;
}
.selected-tag > .closeTag {
    cursor: pointer;
    border-radius: 4px;
    margin: 4px;
}
.selected-tag > .closeTag:active {
    background-color: gray;
}

.date-picker >>> .el-input__inner {
    background-image:url('../../assets/icon_calendar.svg');
    background-repeat:no-repeat;
    background-position-x: 10px;
    background-position-y: center;
    background-size: 16px 16px;
    height: 35px;
}

.date-picker > .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 140px;
}

.time-picker >>> .el-input__inner {
    background-image:url('../../assets/icon_clock.svg');
    background-repeat:no-repeat;
    background-position-x: 10px;
    background-position-y: center;
    background-size: 16px 16px;
    height: 35px;
}

.time-picker > .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100px;
}

.el-input--prefix .el-input__inner {
    padding: 0 8px !important;
    text-align: center !important;
}

/* 右ペインの外側（id="record-list-panel"）はスクロールさせない */
#record-list-panel {
    overflow: hidden;
}

/* 右ペイン内の .scrollable もスクロールさせない */
#record-list-panel .scrollable {
    overflow: hidden;
    display: flex;
    min-height: 0;
    min-width: 0;
}

#record-list-panel .scrollable > * {
    flex: 1;
    min-height: 0;
    min-width: 0;
}

</style>
